import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type ClockPicture from 'modules/employees/store/models/ClockPicture'

import * as styles from './index.vanilla.css'

interface Props {
  clockPicture: ClockPicture
}

const FileViewer = ({ clockPicture }: Props) => {
  const mimeType = clockPicture.attributes.content_type
  const url = clockPicture.attributes.url

  if (mimeType && mimeType.match(/image/)) {
    return <img className={styles.fileviewerImage} src={url} alt="face recognition clock picture" />
  } else {
    return (
      <Box justifyContent="center" alignItems="center">
        <Text.Normal>{i18n.t('documents.no_preview')}</Text.Normal>
      </Box>
    )
  }
}

export default observer(FileViewer)
